import PropTypes from 'prop-types';
import { ensureArray, safeMap, ensureString } from 'utils/safeArray';

export default function CircleHero({ title_lines, image_url, accent_color }) {
  const safeTitleLines = ensureArray(title_lines);
  
  return (
    <div className="ppt-container">
      <div className="flex flex-1 flex-col md:flex-row items-center justify-center gap-8 md:gap-16 h-full">
        <div className="w-full md:w-1/2 text-left space-y-3 md:space-y-6">
          {safeMap(safeTitleLines, (line, index) => (
            <h1
              key={index}
              className="text-3xl md:text-5xl lg:text-7xl font-bold leading-tight tracking-tight text-slate-800"
            >
              {ensureString(line)}
            </h1>
          ))}
        </div>
        <div className="w-full md:w-1/2 flex items-center justify-center">
          {image_url && (
            <div className="relative">
              <div
                className="absolute -inset-3 md:-inset-4 border-3 md:border-4 rounded-full"
                style={{ borderColor: accent_color || '#cc0000' }}
              ></div>
              <img
                src={ensureString(image_url)}
                alt=""
                className="w-48 h-48 md:w-80 md:h-80 lg:w-96 lg:h-96 rounded-full object-cover shadow-2xl"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

CircleHero.propTypes = {
  title_lines: PropTypes.array,
  image_url: PropTypes.string,
  accent_color: PropTypes.string,
};
